import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type SubjectTypeColorsFetchFailedAction = {
	type: 'SUBJECT_TYPE_COLORS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): SubjectTypeColorsFetchFailedAction => ({
	type: 'SUBJECT_TYPE_COLORS_FETCH_FAILED',
	payload,
});
